import React from 'react';
import { Link } from 'react-router-dom';
import { Routes } from 'router/routes';

import s from './styles.module.scss';

interface IProps {
  guid: string;
}

const PatientGuidColumn: React.FC<IProps> = ({ guid }) => {
  return (
    <div className={s['hover-item']}>
      <Link to={Routes.patientGuid(guid)}>
        <strong>{guid}</strong>
      </Link>
    </div>
  );
};

export default PatientGuidColumn;
